export default {"src":"/_next/static/media/zenadmin-logo.f577753c.svg","height":16,"width":104,"blurWidth":0,"blurHeight":0};